import { defineComponent as _defineComponent } from 'vue'
import LinkButton from 'JS/components/LinkButton.vue';
import UiButton from 'JS/components/UiButton.vue';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RewardsGetHelp',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
	(e: 'close'): void
}), expose: any, slots: any, attrs: any }) {



const headerFocuser = ref<HTMLElement | null>(null);

onMounted(()=> {
	headerFocuser.value?.focus();
});


return { __sfc: true,emit, headerFocuser, LinkButton, UiButton }
}

})